import { Routes } from '@angular/router';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { QuestionnaireComponent } from './components/questionnaire/questionnaire.component';
import { WizardComponent } from './components/wizard/wizard.component';
import { SubmittedComponent } from './components/submitted/submitted.component';
import { SomethingWrongComponent } from './components/something-wrong/something-wrong.component';
import { OauthCallbackComponent } from './oauth-callback/oauth-callback.component';

export const routes: Routes = [
    //{ path: '', component: LandingPageComponent }, // Default route (Landing Page)
    { path: '', component: QuestionnaireComponent },
    { path: 'submitted', component: SubmittedComponent },
    { path: 'failure', component: SomethingWrongComponent },
    { path: 'oauth2/callback', component: OauthCallbackComponent}
];
